<div *ngIf="isSuccess" class="flex justify-center gap-4">
  <button
    mat-raised-button
    class="px-4 py-2 bg-brand-surface-muted text-brand-text-secondary hover:bg-brand-border-muted text-sm rounded-md"
    (click)="volver()"
  >
    Volver
  </button>

  <button
    mat-raised-button
    class="bg-brand-primary text-brand-surface px-4 py-2 rounded-md hover:bg-brand-primary-hover text-sm disabled:opacity-50 disabled:cursor-not-allowed"
    (click)="getPDF()"
  >
    Generar PDF
  </button>
</div>

<div *ngIf="isSuccess" id="infoPdf" class="pdf-wrapper">
  <div #pdfContent>
    <div class="pdf-template">
      <div id="watermark" class="watermark">DOCUMENTO INFOMÁTIVO</div>
      <title>Acta de Observaciones</title>

      <div>
        <div class="header">
          <div style="flex: 0 0 120px">
            <img
              [src]="cfg.project.logo"
              [alt]="'Logo ' + cfg.project.name"
              style="max-width: 200px"
            />
          </div>
          <div class="cuadro-solicitud">
            <div class="row-title">N° Ingreso</div>
            <div class="row-value">
              {{ dataId }}
            </div>
            <div class="row-title">Fecha Ingreso</div>
            <div class="row-value">
              {{ expediente_info?.fechaIngreso }}
            </div>
            <div class="row-title">Fecha Emisión</div>
            <div class="row-value">
              {{ expediente_info?.fechaActa }}
            </div>
          </div>
        </div>

        <div class="header-center">
          <h1>ACTA DE OBSERVACIONES</h1>
          <h2>DIRECCIÓN DE OBRAS - I. MUNICIPALIDAD DE TALCA</h2>
        </div>

        <br />
        <div class="datos-expediente">
          <div class="row-title">Expediente:</div>
          <div class="row-value">
            {{ expediente_info?.expediente }}
          </div>

          <div class="row-title">Propietario:</div>
          <div class="row-value">
            {{
              expediente_info?.profesionales?.propietario
                ? expediente_info?.profesionales?.propietario
                : ""
            }}
          </div>

          <div class="row-title">Representante:</div>
          <div class="row-value">
            {{
              expediente_info?.profesionales?.representante
                ? expediente_info?.profesionales?.representante
                : ""
            }}
          </div>

          <div class="row-title">Arquitecto:</div>
          <div class="row-value">
            {{
              expediente_info?.profesionales?.arquitecto
                ? expediente_info?.profesionales?.arquitecto
                : ""
            }}
          </div>

          <div class="row-title">Ubicación:</div>
          <div class="row-value">
            {{ expediente_info?.propiedad ? expediente_info?.propiedad : "" }}
          </div>

          <div class="row-title">ROL:</div>
          <div class="row-value">
            {{ expediente_info?.rol ? expediente_info?.rol : "" }}
          </div>

          <div class="row-title">Materia:</div>
          <div class="row-value">
            {{
              expediente_info?.tipoTramite ? expediente_info?.tipoTramite : ""
            }}
          </div>

          <div class="row-title">Tema:</div>
          <div class="row-value">
            {{
              expediente_info?.temaTramite ? expediente_info?.temaTramite : ""
            }}
          </div>
        </div>

        <p class="intro">
          {{
            expediente_info?.introductorio ? expediente_info?.introductorio : ""
          }}
        </p>

        <table class="tabla-observaciones">
          <tr>
            <th colspan="2" style="background: #d9d9d9">OBSERVACIONES</th>
            <th style="background: #d9d9d9">ART. O NORMA TRANSGREDIDA</th>
          </tr>

          <ng-container
            *ngFor="
              let obs of expediente_info?.actaObservaciones?.observaciones
                ?.items;
              let i = index
            "
          >
            <!-- Fila de título que ocupa todas las columnas -->
            <tr
              *ngIf="
                i === 0 ||
                expediente_info?.actaObservaciones?.observaciones?.items[i - 1]
                  ?.tituloNumero !== obs.tituloNumero
              "
              class="font-semibold text-left capitalize"
            >
              <!-- Cambia el 3 por el número real de columnas de datos -->
              <td colspan="3" style="text-align: left; padding-left: 5%">
                {{ obs.titulo }}
              </td>
            </tr>

            <!-- Fila normal con los datos -->
            <tr>
              <td class="text-left">{{ obs.numero }}</td>
              <td class="">{{ obs.descripcion }}</td>
              <td>{{ obs.norma }}</td>
            </tr>
          </ng-container>
        </table>
      </div>

      <br />
      <div>
        <!-- NOTAS -->
        <div class="notas-title">NOTA:</div>

        <div class="notas-header">
          <p>{{ expediente_info?.notas }}</p>
        </div>
      </div>

      <!-- ====== FIRMAS ====== -->
      <div class="firmas-container">
        <div class="firma-item">
          <img
            *ngIf="firmaUrlArquitecto"
            [src]="firmaUrlArquitecto"
            alt="Firma funcionario"
            class="firma-img"
          />
          <div class="firma-texto">
            <p>
              <strong>
                {{
                  expediente_info?.actaObservaciones?.firmas?.revisor?.nombre
                }}
              </strong>
            </p>
            <p><strong>ARQUITECTO REVISOR</strong></p>
          </div>
        </div>

        <div class="firma-item derecha">
          <img
            [src]="firmaUrlDirector || 'assets/firmas/director.png'"
            alt="Firma director"
            class="firma-img"
          />
          <div class="firma-texto">
            <p>
              <strong>
                {{
                  expediente_info?.actaObservaciones?.firmas?.director?.nombre
                }}
              </strong>
            </p>
            <p><strong>DIRECTOR DE OBRAS MUNICIPALES</strong></p>
          </div>
        </div>
      </div>

      <div class="nota-abreviaturas mb-12">
        <p><strong>NOTA:</strong> Las abreviaturas indicadas corresponden a:</p>
        <div class="abreviaturas-grid">
          <ul>
            <li>
              <strong>- C.I.P.:</strong> Certificado de informaciones previas
            </li>
            <li><strong>- P.R.C.:</strong> Plan regulador comunal</li>
            <li><strong>- N.N.T.:</strong> Nivel natural de terreno</li>
          </ul>
          <ul>
            <li>
              <strong>- O.G.U.C.:</strong> Ordenanza general de urbanismo y
              construcciones
            </li>
            <li>
              <strong>- L.G.U.C.:</strong> Ley general de urbanismo y
              construcciones
            </li>
            <li><strong>- A.U.P.:</strong> Afectación a utilidad pública</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

<html *ngIf="!isSuccess" class="h-full w-full m-0 p-0">
  <head>
    <meta charset="UTF-8" />
    <script src="https://cdn.tailwindcss.com"></script>
    <title>No accesible</title>
  </head>
  <body
    class="fixed inset-0 m-0 p-0 flex items-center justify-center bg-gray-100"
  >
    <div class="bg-white rounded-lg shadow-md p-8 text-center max-w-md">
      <div class="flex justify-center mb-4">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-10 w-10 text-red-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </div>

      <h1 class="text-lg font-semibold text-gray-800 mb-2">
        No es posible acceder a este contenido
      </h1>
      <p class="text-gray-600 text-sm">
        Puede que no tengas los permisos necesarios o el recurso ya no esté
        disponible.
      </p>
    </div>
  </body>
</html>

<p-toast [life]="4000" position="top-right" styleClass="z-[10000]"></p-toast>
